function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from "angular";
import { $uniDebug } from "../uni-debug.module";
var BugToggleBtnDirective = /*#__PURE__*/function () {
  function BugToggleBtnDirective($log, $timeout, UniConfig) {
    _classCallCheck(this, BugToggleBtnDirective);
    _defineProperty(this, "priority", -900);
    this.$log = $log;
    this.$timeout = $timeout;
    this.UniConfig = UniConfig;
    this.restrict = "A";
    this.scope = {
      path: "@"
    };
  }
  return _createClass(BugToggleBtnDirective, [{
    key: "compile",
    value: function compile(element, attrs) {
      this.$log.debug("******** Compile BugToggleBtnDirective", element.html());
      if (!this.UniConfig.debug) {
        attrs.jsonDev = "";
        element.removeAttr("json-dev");
        element.empty();
      }
      this.activo = this.UniConfig.debug;
      return this.link;
    }
  }, {
    key: "link",
    value: function link(scope, element, attrs, ctrls) {
      var _this = this;
      scope.toggleShowDev = function ($event) {
        _this.$log.info("click!!");
        $event.stopImmediatePropagation();
        _this.activo = !_this.activo;
        angular.element("body").toggleClass("hide__dev", !_this.activo);
      };
    }
  }, {
    key: "template",
    value: function template() {
      return "<div if-dev class=\"item dropdown if-dev-noborder\">\n<span ng-click=\"toggleShowDev($event)\" class=\"badge badge-counter glyphaction\">&nbsp;</span>\n<a target=\"_self\" href=\"{{::path}}?_dev=0\" title=\"Debug mode\"> <i class=\"fa fa-bug icon-md\"></i> </a>\n</div>";
    }
  }]);
}();
$uniDebug.directive("bugToggleBtn", ["$log", "$timeout", "UniConfig", function ($log, $timeout, UniConfig) {
  return new BugToggleBtnDirective($log, $timeout, UniConfig);
}]);